import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'

const ShopHappyReminder = (props) => ( 
	<Container_s fluid>
		<Container_1000>
			<h4>Our candles are crafted with you and the environment in mind!</h4>
			<p>We use cotton wicks that are lead free.</p>
			<p>Our candles are made using sustainably sourced palm wax.</p>
		</Container_1000>
	</Container_s>
);

export default ShopHappyReminder;

const Container_s = styled(Container)`
	padding: 20px 0 20px 0!important;
	text-align: center;
	background-color: #D0C1A0;
	margin: 0 0 40px 0;
`;

const Container_1000 = styled(Container)`
	padding: 0!important;
	max-width: 1000px;
	margin: 0 auto;
	background-color: #D0C1A0;
	font-family: 'Raleway';
	
	h4 {
		font-size: 14px;
		font-weight: bold;
		margin-bottom: 15px;
		margin-top: 20px;
		${media.md` font-size: 16px; `}
		${media.xl` font-size: 18px; `}
	}

	p {
		font-size: 12px;
		font-weight: bold;
		color: #76451F;
		margin-bottom: 3px;
		${media.md` font-size: 14px; `}
		${media.xl` font-size: 16px; `}
	}
`;


// WEBPACK FOOTER //
// ./src/components/ShopHappyReminder.js